// @ts-nocheck
import { Text } from '@blueprintjs/core';
import { Box, Stack } from '@/components';
import {
  ImportDropzoneField,
  ImportDropzoneFieldProps,
} from '@/containers/Import/ImportDropzoneFile';
import {
  useGetPresignedUrlImage,
  useUploadAttachments,
} from '@/hooks/query/attachments';
import styles from './UploadLogoPopoverContent.module.scss';
import { MIME_TYPES } from '@/components/Dropzone/mine-types';
import { useState } from 'react';

interface UploadLogoPopoverContentProps {
  initialValue?: string;
  value?: string;
  onChange?: (value: string) => void;
  onUploadedChange?: (value: string) => void;
  dropzoneFieldProps?: ImportDropzoneFieldProps;
}

/**
 * Uploads and list the attachments with ability to delete particular attachment.
 * @param {UploadLogoPopoverContentProps}
 */
export function UploadLogoPopoverContent({
  initialValue,
  value,
  onChange,
  onUploadedChange,
  dropzoneFieldProps,
}: UploadLogoPopoverContentProps) {
  const { data } = useGetPresignedUrlImage(value, { enabled: !!value });

  const [logoError, setLogoError] = useState<string | null>(null);
  const MAX_FILE_SIZE_KB = 150;
  // Uploads the attachments.
  const { mutateAsync: uploadLogo } = useUploadAttachments({
    onSuccess: (data) => {
      onChange(data.data.data.key);
      onUploadedChange && onUploadedChange(newLocalFiles);
    },
  });

  // Handle change dropzone.
  const handleChangeDropzone = (file: File) => {
    if (!file) {
      onChange(null);
      return;
    }

    const fileSizeKB = file.size / 1024;
    console.log(file.size, fileSizeKB > MAX_FILE_SIZE_KB)
    if (fileSizeKB > MAX_FILE_SIZE_KB) {
      setLogoError(`File must be under ${MAX_FILE_SIZE_KB}KB.`);
      return;
    }

    setLogoError(null);
    const formData = new FormData();
    const key = Date.now().toString();

    formData.append('file', file);
    formData.append('internalKey', key);

    uploadLogo(formData);
  };

  return (
    <div className={styles.content}>
      <div>
        <Text className={styles.label}>Upload Logo</Text>
        <Stack spacing={0}>
          <ImportDropzoneField
            uploadIcon={
              <div>
                {data?.presigned_url && (
                  <img
                    src={data.presigned_url}
                    alt={'organization-logo'}
                    style={{ maxWidth: 150 }}
                  />
                )}
              </div>
            }
            value={data?.presigned_url ?? null}
            title={''}
            classNames={{ root: styles.dropzoneRoot }}
            onChange={handleChangeDropzone}
            dropzoneProps={{
              accept: [MIME_TYPES.png, MIME_TYPES.jpeg],
              maxSize: 150 * 1024,
            }}
            hintText={
              <>
                <Box>Supported Formats: PNG, JPEG</Box>
                <Box>Maximum size: 150KB</Box>
              </>
            }
            {...dropzoneFieldProps}
            maxFiles={1}
            multiple={false}
          />
          {logoError && (
            <Box className={styles.errorText} style={{ color: 'red', marginTop: '8px' }}>
              {logoError}
            </Box>
          )}
        </Stack>
      </div>
    </div>
  );
}
